import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { useEffect, useState } from 'react';
import cn from 'classnames';
import { app } from '@microsoft/teams-js';
import i18n from 'i18next';
import TfGridLoading from '@components/goals/TfGridLoading';
import { checkHostContextInExtension } from '../helpers/hostContextHelper';
var SuspanseFallbackPage = function SuspanseFallbackPage(props) {
    var customText = props.customText;
    var _useState = _sliced_to_array(useState(false), 2), isDark = _useState[0], setIsDark = _useState[1];
    useEffect(function() {
        app.getContext().then(function(context) {
            var _context_app;
            if ((context === null || context === void 0 ? void 0 : (_context_app = context.app) === null || _context_app === void 0 ? void 0 : _context_app.theme) === 'dark') {
                setIsDark(true);
            } else {
                setIsDark(false);
            }
        });
    }, []);
    return /*#__PURE__*/ _jsxs("section", {
        className: cn('ms-welcome__progress ms-u-fadeIn500 fallback-page', {
            dark: isDark,
            'in-extension': checkHostContextInExtension()
        }),
        children: [
            /*#__PURE__*/ _jsx(TfGridLoading, {
                isDark: isDark,
                showLogo: true
            }),
            /*#__PURE__*/ _jsx("span", {
                className: "loadingText",
                children: customText || i18n.t('SuspenseFallbackPage_Loading', 'Loading...')
            })
        ]
    });
};
export default SuspanseFallbackPage;
